module.exports = __webpack_public_path__ + "media/icons/pochodzenie-kraj-a55c2cba.png";